import { axiosCore } from './http-core-service';
import { env } from '../env';

const statutOK = 200;
export const sendPasswordRetrieveRequest = async (data: { login: string }) => {
    const url = {
        urlReset: env.REACT_APP_URL_AEL + '/reinitialisation-mot-de-passe',
    };
    const response = await axiosCore.post('/mot_de_passe/reinitialisation/' + data.login, url);
    return response.data;
};

/**
 * Méthode qui valide le compte créé
 * @return si valide
 */
export const validateNewPassword = async (token: string | undefined, password: string) => {
    let data = {
        password: password,
    };

    const response = await axiosCore.patch('/mot_de_passe/reinitialisation/' + token, data);
    const success = response.status === statutOK;
    return {
        success: success,
        message: response.data.message,
    };
};
